'use strict';

export default function () {
    const SELECTOR = '.js-video-preview';

    for (const element of document.querySelectorAll(SELECTOR)) {
        const video = element.querySelector('video');

        if (!video) {
            continue;
        }

        const url = video.dataset.src;

        if (!url) {
            continue;
        }

        let loaded = false;
        let fading = false;

        const play = () => {
            if (!fading) {
                video.currentTime = 0;
                video.play();
            }
        };

        element.addEventListener('mouseenter', () => {
            if (!loaded) {
                loaded = true;
                video.src = url;

                // play once the video is ready
                video.addEventListener('canplay', () => {
                    fading = false;
                    play();
                }, { once: true });
            } else {
                fading = false;
                play();
            }
        });

        element.addEventListener('mouseleave', () => {
            fading = true;
            setTimeout(() => {
                if (fading) {
                    video.pause();
                    fading = false;
                }
            }, 400); // delayed pause for smooth UX - this should be same as css transition time
        });
    }
}
